import { render, staticRenderFns } from "./HolidaysManagedBySystemUser.vue?vue&type=template&id=79593c1d"
import script from "./HolidaysManagedBySystemUser.vue?vue&type=script&lang=js"
export * from "./HolidaysManagedBySystemUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports